import { render, staticRenderFns } from "./SideMention.vue?vue&type=template&id=e7234042&scoped=true"
import script from "./SideMention.vue?vue&type=script&lang=js"
export * from "./SideMention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7234042",
  null
  
)

export default component.exports